import Control from "ol/control/Control";


let gdSelect;

class GdControl extends Control {

    constructor(opt_options) {
        const options = opt_options || {};

        const element = document.createElement('div');

        super({
            element: element
        });
        this.set('name', options.name ? options.name : null);
    }

    handleClick = function (type, evt) {
        evt.preventDefault();

        if (gdControl) {
            gdControl.cleanUp();
        }

        $('.gd-btn-control').removeClass('gd-btn-active');
        evt.target.classList.add('active');
        evt.target.classList.add('gd-btn-active');
        //gdControl = this;
        this.getInteraction();
    }

    changeSelectInteraction = function (newSelect) {
        let map = this.getMap();

        map.removeInteraction(gdSelect);

        gdSelect = newSelect;
        map.addInteraction(gdSelect);
    }

    cleanUp = function () {
        //gdCleanupMap();
    }
}
export default GdControl;
